import type { JSX, RefObject } from 'react';
import ContactSection from '@layouts/sections/ContactSection';
import CostSection from '@layouts/sections/CostSection';
import CreativesSection from '@layouts/sections/CreativesSection';
import IASMetricsSection from '@layouts/sections/IASMetricsSection';
import IntroSection from '@layouts/sections/IntroSection';
import OverviewSection from '@layouts/sections/OverviewSection';
import PerformanceSection from '@layouts/sections/PerformanceSection';
import SummarySection from '@layouts/sections/SummarySection';
import type { TReportSection } from '@services/types';

export interface ISectionComponentProps {
  sectionData: TReportSection;
  slideRefs: Map<string, RefObject<HTMLDivElement | null>>;
  visibleSubSections: Set<string>;
}
export interface IReportContentProps {
  sectionData: TReportSection[];
  slideRefs: Map<string, RefObject<HTMLDivElement | null>>;
}

const sectionComponents: {
  [key: string]: (props: ISectionComponentProps) => JSX.Element;
} = {
  intro: IntroSection,
  overview: OverviewSection,
  performance_kpi: PerformanceSection,
  cost: CostSection,
  contact: ContactSection,
  creatives: CreativesSection,
  ias_metrics: IASMetricsSection,
  summary: SummarySection,
  /*
  studio: StudioSection,
  all_approaches: SolutionsSection,
  */
};

export default sectionComponents;
